import firebase from "firebase/app";
import "firebase/messaging";
import "firebase/auth";
import config from "./firebase-config.json";

// if (!firebase.apps.length) {
//   console.log("Initialize firebase...");
//   firebase.initializeApp(config, "Semanggi Back Office");
// } else {
//   firebase.app();
// }

export default !firebase.apps.length
  ? firebase.initializeApp(config, "Semanggi Back Office")
  : firebase.app();
